<template>
  <div>
    <div class="mainHeader" v-if="isLoggedIn">
      <!--TOP NAV-->
      <div class="Vlt-grid">
        <!--TITLE-->
        <div class="Vlt-col mainHeaderTitle Vlt-col--2of4">
          <div>
            <span class="logoImgWrapper">
              <img style="height: 48px;" src="./assets/logos/vonage-logo.svg" alt="logo">
            </span>&nbsp;
          </div>
        </div>

        <div class="Vlt-col Vlt-col--2of4">
          <div class="Vlt-grid Vlt-right alignRightGrid">
            <div class="Vlt-col">
              <div class="Vlt-grid">
                <div class="Vlt-col">
                  <h5 class="Vlt-blue"><vlt-icon small icon="user"/>&nbsp{{profileName}}</h5>
                </div>
                <div class="Vlt-grid__separator"></div>
                <div class="Vlt-col Vlt-col--2of4" v-if="isAdmin">
                  <div class="tooltip-item">
                    <span v-if="isAdminLayout">{{$t('message.turn_off_admin_layout')}}</span>
                    <span v-else>{{$t('message.turn_on_admin_layout')}}</span>
                    &nbsp;
                    <vlt-tooltip
                      icon="info"
                      :title="$t('message.change_layout')"
                      class="Vlt-grey"
                      position="right"
                    >
                      <vlt-switch
                        :checked="isAdminLayout"
                        :disabled="loading"
                        @input="onChangeLayout"
                      />
                    </vlt-tooltip>
                  </div>
                </div>
                <div :class="isAdmin ? 'Vlt-col Vlt-col--2of4' : 'Vlt-col'">
                  <div class="logoutLink">
                    <a href="#"
                       @click.prevent="logout"
                       class="Vlt-text-link Vlt-logout Vlt-black" v-if="isLoggedIn">
                      <vlt-icon icon="exit" small class="Vlt-black"/>&nbsp;
                      {{$t('message.btnLogout')}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <router-view :logout="logout"></router-view>
  </div>
</template>

<script>
import VoltaIcons from '@vonagevolta/core/dist/symbol/volta-icons.svg';
import VoltaFlags from '@vonagevolta/core/dist/symbol/volta-flag-icons.svg';
import BrandIcons from '@vonagevolta/core/dist/symbol/volta-brand-icons.svg';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {
  LOGOUT,
  SET_TOKENS,
  GET_STATUS,
  GET_STATUS_WITH_FEED_NUMBER,
  SEARCH_BRIDGE_BY_NUMBER,
  SET_IS_POLLING_STATUS,
} from 'Store/action-types';
import {
  SET_ADMIN_LAYOUT
} from 'Store/mutation-types';

import VltBrandIcon from 'Components/common/VltBrand.vue';
import { VltIcon, VltSwitch, VltTooltip } from '@vonagevolta/vue';
import EventBus from './utils/event-bus';
import VonageIcon from './assets/customIcons/vonage_black.svg';

import {
    POLL_STATUS_INTERVAL_SEC,
    POLL_STATUS_TIMEOUT_SEC,
} from "Constants/settings";

export default {
  components: {
    VltIcon,
    VltBrandIcon,
    VonageIcon,
    VltSwitch,
    VltTooltip,
  },
  data() {
    return {
      VoltaIcons,
      VoltaFlags,
      BrandIcons,
      timeoutID: null,
      statusId: null,
      bridgePollingId: null,
      feedNumber: null,
      pollingTime: 0,
      startingPolling: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      isAdmin: 'isAdmin',
      userStatus: 'getUserStatus',
      searchNumber: 'getSearchNumber',
      profileName: 'getProfileName',
      userActiveCall: 'getUserActiveCall',
      searchedBridge: 'getSearchedBridge',
      searchNumberErr: 'getSearchNumberErr',
      isPollingStatus: 'getIsPollingStatus',
      loading: 'getLoading',
      isAdminLayout: 'getIsAdminLayout',
    }),
  },

  methods: {
      async logout() {
        await this.logoutA();
        this.$router.push({ name: 'login'})
      },
    ...mapMutations({
      changeLayout: SET_ADMIN_LAYOUT // map `this.add()` to `this.$store.commit('increment')`
    }),
    ...mapActions({
      logoutA: `${LOGOUT}`,
      setTokens: `${SET_TOKENS}`,
      getStatus: `${GET_STATUS}`,
      getStatusWithFeedNumber: `${GET_STATUS_WITH_FEED_NUMBER}`,
      search: `${SEARCH_BRIDGE_BY_NUMBER}`,
      setIsPollingStatus: `${SET_IS_POLLING_STATUS}`,
    }),
    onChangeLayout(val) {
      this.changeLayout(val);
    },
    async startPollStatus() {
      this.startingPolling = true;
      console.log('Start Status Polling');
      this.setIsPollingStatus(true);
      await this.getStatus(this.feedNumber);
      this.pollingTime = POLL_STATUS_INTERVAL_SEC;
      this.startingPolling = false;
      this.statusId = setInterval(async () => {
        if (this.pollingTime >= POLL_STATUS_TIMEOUT_SEC) {
          this.stopPollStatus();
        }
        await this.getStatus(this.feedNumber);
        this.pollingTime += POLL_STATUS_INTERVAL_SEC;
      }, (POLL_STATUS_INTERVAL_SEC * 1000) );
    },
    stopPollStatus() {
      console.log('Stop Status Polling');
      this.setIsPollingStatus(false);
      this.pollingTime = 0;
      clearInterval(this.statusId);
      this.statusId = null;
    },
  },
  watch: {
    loading(current) {
        // console.log('current LOADING: ', current)
    },
    async isPollingStatus(current) {
      if (current && !this.statusId && !this.startingPolling) {
        this.startingPolling = true;
        await this.startPollStatus();
        this.startingPolling = false;
      } else if (!current && this.statusId) {
        this.stopPollStatus();
      }
    },
    async isLoggedIn(newProp) {
      if (newProp) {
        if (!this.statusId && !this.isPollingStatus && !this.startingPolling) {
          let id = setInterval(async () =>{
              if (!this.loading) {
                clearInterval(id);
                await this.startPollStatus();
              }
          },2000);
        }
      } else {
        this.stopPollStatus();
      }
    },
    searchNumberErr(newProp) {
      if (newProp && newProp.number) {
        this.feedNumber = newProp.number;
      } else if (!newProp && !this.searchedBridge  && !this.userActiveCall) {
        this.feedNumber = null;
      }
    },
    searchedBridge(newProp) {
      if (newProp && newProp.bridge) {
        this.feedNumber = newProp.bridge.feedNumber;
      } else if (!newProp && !this.searchNumberErr && !this.userActiveCall) {
        this.feedNumber = null;
      }
    },
    userActiveCall(newProp) {
      if (newProp && newProp.call) {
        this.feedNumber = newProp.call.feedNumber;
      } else if (!newProp && !this.searchedBridge && !this.searchNumberErr) {
          this.feedNumber = null;
      }
    },
    profileName(current) {

    },
    isAdminLayout(current) {
      if (current) {
        // this.$router.push({name: 'dashboard'})
      }
    }
  },
  mounted() {
    EventBus.$on('logout', this.logout);
  },
  created() {
    this.setTokens();
  },
  beforeDestroy() {
    this.stopPollStatus();
    EventBus.$off('logout');
  },
};
</script>

<style lang="scss">
  @import "assets/style/style.scss";

  html,
  body {
    height: 100%; /* needed for proper layout */
  }

  body {
    overflow: hidden;
    background-color: $grey-lighter;
  }

  .mainHeader {
    background-color: $white;
    box-shadow: 0 1px 8px rgba(44, 45, 48, 0.2);
    padding: 16px;

    .mainHeaderTitle {
      color: $blue;
      font-size: 2em;
      float: left;
      font-weight: 600;

      .logoImgWrapper {
        //border-right: 2px solid $grey;

        .headerLogoImg {
          height: 24px;
        }
      }

    }

    .adminDashboardLink {
      padding: 0 8px 0 0;
    }

    .logoutLink {
    }
  }

  .alignRightGrid {
    justify-content: right;
  }

</style>
